import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';
import type {
  PhoneCsv,
  PhoneCsvPatch,
  GetPhoneCsvsRequest,
} from '@/apis/generated/dialbunny';
import { PhoneCsvFromJSON } from '@/apis/generated/dialbunny';

export type PhoneCsvStore = StoreEntity<
  PhoneCsv,
  'id',
  GetPhoneCsvsRequest,
  File,
  PhoneCsvPatch
>;

export const usePhoneCsvStore = apiStoreFactory<
  PhoneCsvStore['entity'],
  PhoneCsvStore['id'],
  PhoneCsvStore['filter'],
  PhoneCsvStore['createInput'],
  PhoneCsvStore['updateInput']
>(
  STORE.PHONE_CSV,
  { entityIdKey: 'id' },
  {
    create: async (file: File, { dialbunnyApi }) => {
      const result = await dialbunnyApi.uploadPhoneCsv({
        file,
      });
      return PhoneCsvFromJSON(result);
    },
    readAll: async (filter, { dialbunnyApi }, signal) => {
      return await dialbunnyApi.getPhoneCsvsRaw(filter, { signal });
    },
    read: async (csvId: string, { dialbunnyApi }) => {
      const result = await dialbunnyApi.getPhoneCsv({ csvId });
      return result;
    },
    discard: async (csvId: string, { dialbunnyApi }) => {
      await dialbunnyApi.deletePhoneCsv({ csvId });
    },
    update: async (
      csvId: string,
      phoneCsvPatch: PhoneCsvPatch,
      { dialbunnyApi },
    ) => {
      const result = await dialbunnyApi.updatePhoneCsv({
        csvId,
        phoneCsvPatch,
      });
      return result;
    },
  },
);
